// Table ID
export const TRIANGULATIONS_TABLE_ID = 'triangulations_table';
export const TRIANGULATIONS_RATIOS_TABLE_ID = 'triangulations_ratios_table';
export const LINK_RATIOS_TABLE_ID = 'link_ratios_table';
export const DEV_FACTORS_TABLE_ID = 'dev_factors_table';
export const ULT_TABLE_ID = 'ult_table';
